module.exports = __webpack_public_path__ + "img/mlt.a816f3a2.svg";